import React from 'react';
import { Route, Redirect, useLocation, RouteComponentProps } from 'react-router-dom';
import { Location } from 'history';
import { useDetectIsLogged } from '../../helpers/getUser';
import { useRouteHelper } from '../../hooks/routesHelpers';

export default function RestrictedRoute({ component, ...rest }: { component: React.ComponentType<RouteComponentProps> }) {
  const isLogged = useDetectIsLogged();
  const { getRoute } = useRouteHelper();
  const location = useLocation<Location>();
  const { from }: any = location.state || { from: { pathname: getRoute('home') } };
  const Component = component;
  if (isLogged) return <Redirect to={from} />;
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
